import { GetDataAbsenteeismSupport, GetDataCodeCIE, GetAllAbsenteeismIssuer, GetAllDetailAbsenteeisms, GetAllTypeAbsenteeisms, GetAllDataAbsenteeismSupport, DeleteRegisterAbsenteeismSupport, SaveRegisterAbsenteeismSupport } from '../../shared/data-services/AbsenteeismSupport-Service';

export async function getDataEmployeeAbsenteeismSupport (employeeId, companyId, temporalId){
    const data = await GetDataAbsenteeismSupport(employeeId, companyId, temporalId);
    return data || [ ];
};

export async function GetCodeCIE (searchTerm){
    const data = await GetDataCodeCIE(searchTerm);
    return data || [ ];
};

export async function GetDataAbsenteeismIssuer (){
    const data = await GetAllAbsenteeismIssuer();
    return data || [ ];
};

export async function GetDataDetailAbsenteeisms (){
    const data = await GetAllDetailAbsenteeisms();
    return data || [ ];
};

export async function GetDataTypeAbsenteeisms (){
    const data = await GetAllTypeAbsenteeisms();
    return data || [ ];
};

export async function GetDataAllAbsenteeismSupport (employeeId, companyId, temporalId){
    const data = await GetAllDataAbsenteeismSupport(employeeId, companyId, temporalId);
    return data || [ ];
};

export async function DeleteAbsenteeismSupport (id, employeeId){
    const data = await DeleteRegisterAbsenteeismSupport(id, employeeId);
    return data || [ ];
};

export async function saveAbsenteeismSupport (data){
    const result = await SaveRegisterAbsenteeismSupport(data);
    return result;
  };